// ----------------- SUBMIT TRANSACTION_FINALIZATION  -----------------
export const TRANSACTION_FINALIZATION_LOADING =
	'TRANSACTION_FINALIZATION_LOADING';
export const TRANSACTION_FINALIZATION_SUCCESS =
	'TRANSACTION_FINALIZATION_SUCCESS';
export const TRANSACTION_FINALIZATION_ERROR = 'TRANSACTION_FINALIZATION_ERROR';
